<template>
  <div class="container-fluid">
    <div class="row body-row">
      <div class="col-md-3 col-lg-2 p-0 d-md-block bg-dark">
        <nav-main></nav-main>
      </div>
      <div class="col-md-9 ms-sm-auto col-lg-10 pt-3 ">
        <my-breadcrumb></my-breadcrumb>
        <div class="restaurants">
          <div class="row my-3">
            <h2 class="">{{ $t('statistics.title') }}</h2>
          </div>
          <div class="row">
            <div class="mb-3 col-12 col-md-3">
              <select v-model="selectedRest" class="form-select form-select-sm" aria-label="Select category">
                <option disabled value="">{{ $t('statistics.select') }}</option>
                <option v-for="(value, key) in this.RESTAURANTS"
                        :key="key"
                        :value="value.id">
                  {{ value.title }}
                </option>
              </select>
            </div>
            <div class="mb-3 col-12 col-md-6">
              <DatePicker v-model.range="selectedDate" mode="dateTime" :color="calendarColor" hide-time-header is24hr>
                <template #default="{ inputValue, inputEvents }">
                  <div class="d-flex justify-center align-items-center">
                    <input class="form-control form-control-sm" :value="inputValue.start" v-on="inputEvents.start" />
                    <svg class="mx-2" width="1.5rem" height="1.5rem" fill="gray">
                      <use xlink:href="../../assets/ico/bootstrap-icons.svg#arrow-right"/>
                    </svg>
                    <input class="form-control form-control-sm" :value="inputValue.end" v-on="inputEvents.end" />
                  </div>
                </template>
              </DatePicker>
            </div>
            <div class="mb-3 col-1">
              <div v-if="!checkInputs" class="btn btn-secondary btn-sm"
                   data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('statistics.btnHelp')">Ok</div>
              <button v-else
                  @click="getStatistic()"
                  class="btn btn-success btn-sm">Ok</button>
            </div>

          </div>
          <div class="row">
            <div v-if="this.STATISTICS_LOADING" class="col-12 mb-4">
              <div class="spinner-border h4 fw-normal text-dark"
                   role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <div v-if="this.STATISTICS_ITEM" class="col-12 col-md-8">
              <p>{{ $t('statistics.statisticsFrom') }} {{ timeForStatistic(this.STATISTICS_ITEM.start_date) }} {{ $t('statistics.statisticsTo') }} {{ timeForStatistic(this.STATISTICS_ITEM.end_date) }}</p>
              <table class="table table-sm table-hover">
                <tbody>
                  <tr v-for="(value, key) in this.STATISTICS_ITEM">
                    <td>{{ key }}</td>
                    <td>{{ value }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavMain from "@/components/modules/NavMain";
import MyBreadcrumb from "@/components/modules/Breadcrumb";
import {mapGetters} from "vuex";
import {Tooltip} from "bootstrap";
import { ref } from 'vue';
import { Calendar, DatePicker } from 'v-calendar';
import 'v-calendar/style.css';
export default {
  name: "Statistics",
  components: {NavMain, MyBreadcrumb, Calendar, DatePicker },
  data() {
    return {
      selectedRest: '',
      selectedDate: {
        start: null,
        end: null
      },
      calendarColor: ref('purple')
    }
  },
  computed: {
    ...mapGetters([
      'RESTAURANTS',
      'STATISTICS_ITEM',
      'STATISTICS_LOADING',
      'SELECTED_RESTAURANT',
      'SELECTED_DATE',
    ]),
    checkInputs() {
      if (
          this.selectedRest === '' ||
          this.selectedDate.start === null ||
          this.selectedDate.end === null
      ) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    getStatistic() {
      function changeDate(date) {
        const timezoneOffset = date.getTimezoneOffset();
        const timezoneOffsetMs = timezoneOffset * 60 * 1000;
        const formattedString = new Date(date.getTime() - timezoneOffsetMs).toISOString();
        return formattedString.slice(0, 19)
      }
      let data = {
        id: this.selectedRest,
        dates: {
          start_date: changeDate(this.selectedDate.start),
          end_date: changeDate(this.selectedDate.end)
        }
      }
      this.$store.dispatch('getStatisticsItem', data)
    },
    timeForStatistic(time) {
      let date = new Date(time)
      let options = {
        era: undefined,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        weekday: undefined,
        timezone: 'UTC',
        hour: 'numeric',
        minute: 'numeric',
        second: undefined
      };
      return date.toLocaleString("ru", options)
    },
  },
  watch: {
    selectedRest(e) {
      this.$store.commit('setSelectedRestaurant', e)
    },
    selectedDate: {
      handler(e) {
        this.$store.commit('setSelectedDate', e)
      },
      deep: true
    }
  },
  mounted() {
    const start = async () => {
      await this.$store.dispatch('getRestaurants');
    }
    start().then( () => {
      this.updateStatistics
    })
    //initialization bootstrap tooltips
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    })
  },
  created() {
    this.selectedRest = this.SELECTED_RESTAURANT
    this.SELECTED_DATE ? this.selectedDate = this.SELECTED_DATE : ''
  },
}
</script>

<style scoped>

</style>